import { Card, HealthGauge, TrendIndicator } from '@/components/common'

interface AssetHealthCardProps {
  asset: {
    id: string
    healthScore: number
    status: string
  }
}

export default function AssetHealthCard({ asset }: AssetHealthCardProps) {
  return (
    <Card title="Health Assessment">
      <div className="flex items-center gap-6">
        <HealthGauge value={asset.healthScore} size="md" />
        <div className="flex-1 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-surface-400">Trend</span>
            <TrendIndicator direction="down" value={2.1} label="vs 7d avg" />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-surface-400">Prediction</span>
            <span className="text-sm text-surface-200">Stable next 24h</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-surface-400">Last Check</span>
            <span className="text-sm text-surface-200">2 min ago</span>
          </div>
        </div>
      </div>
    </Card>
  )
}
